// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeTextBlockAddTemplate_heading__3ce8V","buttonLink":"LandscapeTextBlockAddTemplate_buttonLink__Qj1+Y"};